import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import * as echarts from "echarts";
import "@/assets/font/font.css";
import "@/assets/iconfont.css";
import '@/assets/icons/index.js'
import '@/utils/polyfill.js';
import Cookies from 'js-cookie';
import moment from 'moment';
import Print from 'vue-print-nb';
import _ from 'lodash';
import toFixedRepair from '@/utils/toFixedRepair.js';  //修复toFixed方法的bug
import VueLazyload from 'vue-lazyload'

import plugins from './plugins'; // plugins
import directive from './directive'; // directive
// 分页组件
import Pagination from "@/components/Pagination";
// 文件上传组件
import FileUpload from "@/components/FileUpload";
// 自定义表格工具组件
import RightToolbar from "@/components/RightToolbar"
// 图片上传组件
import ImageUpload from "@/components/ImageUpload";
// 图片预览组件
import ImagePreview from "@/components/ImagePreview";
// 查询字典、文件预览、获取系统参数
import { getDicts, filePreview, getConfigKey } from "@/api";
// 字典数据组件
import DictData from '@/components/DictData';
// 金额格式化
import { sumFormater, tonnageFormater } from '@/utils/sumFormater.js';
// 下载文件
import { downLoadFile } from '@/utils/download.js';
// 导出
import { download } from '@/utils/request';
Vue.use(ElementUI, {
    size: Cookies.get('size') || 'medium' // set element-ui default size
});
Vue.use(directive);
Vue.use(toFixedRepair);
Vue.use(plugins);
Vue.use(Print);
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: require('@/assets/images/not-img.png'),
    loading: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjVmN2ZhIi8+PGNpcmNsZSBjeD0iNTAiIGN5PSI1MCIgcj0iOCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjYzBjNGNjIiBzdHJva2Utd2lkdGg9IjIiPjxhbmltYXRlVHJhbnNmb3JtIGF0dHJpYnV0ZU5hbWU9InRyYW5zZm9ybSIgdHlwZT0icm90YXRlIiBmcm9tPSIwIDUwIDUwIiB0bz0iMzYwIDUwIDUwIiBkdXI9IjFzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIvPjwvY2lyY2xlPjwvc3ZnPg==',
    attempt: 2,
    throttleWait: 200
});
Vue.component('FileUpload', FileUpload);
Vue.component('ImageUpload', ImageUpload);
Vue.component('ImagePreview', ImagePreview);
Vue.component('RightToolbar', RightToolbar);
Vue.component('Pagination', Pagination);
DictData.install();

//关闭ElementUI个别组件默认属性
ElementUI.Select.props.popperAppendToBody.default = false;
ElementUI.Popover.props.appendToBody = false;
ElementUI.Cascader.props.appendToBody = false;
ElementUI.DatePicker.props.appendToBody = false;

Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.prototype.$moment = moment;
Vue.prototype.getDicts = getDicts;
Vue.prototype.sumFormater = sumFormater;
Vue.prototype.tonnageFormater = tonnageFormater;
Vue.prototype.downLoadFile = downLoadFile;
Vue.prototype.filePreview = filePreview;
Vue.prototype.getConfigKey = getConfigKey;
Vue.prototype.export = download;
Vue.prototype._ = _;

new Vue({
    router,
    store,
    render: (h) => h(App),
    beforeCreate() {
        Vue.prototype.$bus = this;
    }
}).$mount("#app");
